import { TextSource } from './types';
import { CONTACT, TEAM, ANTCZAK_GROUP, PARTNERS } from '../siteData';

/**
 * Stammdaten als bearbeitbare Texte: Kontaktdaten, Team, Partner, Antczak Group.
 *
 * Die Ausgangswerte stehen weiterhin in `siteData.ts` — dort, wo auch Bilder,
 * Koordinaten und Navigation gepflegt werden. Diese Datei macht sie lediglich
 * bearbeitbar, ohne sie ein zweites Mal aufzuschreiben.
 *
 * Achtung bei den Kontaktdaten: `useContact()` leitet aus der angezeigten Nummer
 * die Verknüpfungen `tel:` und `wa.me` ab, aus der Adresse jedoch **nicht** die
 * Kartenposition (`OFFICE_COORDS`) — und die Firmendaten im JSON-LD von
 * `public/index.html` stehen ohnehin statisch dort. Ein Umzug bleibt deshalb
 * eine Änderung am Code, kein Textwechsel.
 */
export const STAMMDATEN: TextSource = {
  'kontaktdaten.firma': { text: CONTACT.company, max: 60 },
  'kontaktdaten.strasse': { text: CONTACT.street, max: 60 },
  'kontaktdaten.plz': { text: CONTACT.zip, max: 10 },
  'kontaktdaten.ort': { text: CONTACT.city, max: 40 },
  'kontaktdaten.telefon': { text: CONTACT.phoneLabel, max: 30 },
  'kontaktdaten.whatsapp': { text: CONTACT.whatsappLabel, max: 30 },
  'kontaktdaten.email': { text: CONTACT.email, max: 60 },

  ...Object.fromEntries(
    TEAM.flatMap((member, index) => [
      [`team.${index + 1}.name`, { text: member.name, max: 40, label: `Team ${index + 1} — Name` }],
      [`team.${index + 1}.rolle`, { text: member.role, max: 44, label: `Team ${index + 1} — Aufgabe` }],
    ]),
  ),

  ...Object.fromEntries(
    ANTCZAK_GROUP.map((item, index) => [
      `gruppe.${index + 1}.name`,
      { text: item.name, max: 60, label: `Antczak Group ${index + 1}` },
    ]),
  ),

  ...Object.fromEntries(
    PARTNERS.map((partner, index) => [
      `partner.${index + 1}.name`,
      { text: partner.name, max: 70, label: `Partner ${index + 1}` },
    ]),
  ),
};

export default STAMMDATEN;
